import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FastForwardFilledSvg from "@ant-design/icons-svg/es/asn/FastForwardFilled";
import AntdIcon from "../components/AntdIcon";
var FastForwardFilled = function FastForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastForwardFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FastForwardFilled.displayName = 'FastForwardFilled';
}
export default /*#__PURE__*/React.forwardRef(FastForwardFilled);